var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseProductModal',{attrs:{"code":_vm.code,"value":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }